import { Box, Text, useTheme } from '@ltvco/refresh-lib/theme';
import { NeighborhoodSearchForm } from '@ltvco/refresh-lib/v2';
import { MapRounded } from '@mui/icons-material';

import RecentSearchSuggestions from './RecentSearchSuggestions';

interface NeighborhoodReportHeaderProps {
  address: string;
  onSearch: (address: string) => void;
  onSuggestionClick: (address: string) => void;
  headerText?: string;
  subheaderText?: string;
}

const NeighborhoodReportHeader = ({
  address,
  onSearch,
  onSuggestionClick,
  headerText = 'Neighborhood Report',
  subheaderText = 'Look Up Neighborhood Insights for other locations!',
}: NeighborhoodReportHeaderProps) => {
  const theme = useTheme();

  return (
    <>
      <Box marginTop={0}>
        <Text
          variant="h1"
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: 4.5,
            '& svg': { mr: 1 },
          }}
        >
          <MapRounded
            sx={{ color: theme.palette.primary.main }}
            fontSize="large"
          />
          {headerText}
        </Text>
        <Box>
          <Text variant="h2" sx={{ mb: 4 }}>
            {subheaderText}
          </Text>
        </Box>
      </Box>
      <NeighborhoodSearchForm onSubmit={onSearch} initialValue={address} />
      <RecentSearchSuggestions
        currentSearchAddress={address}
        onSuggestionClick={onSuggestionClick}
      />
    </>
  );
};

export default NeighborhoodReportHeader;
